export const DUMMY_ASSIGNMENT_QUESTIONS_ONE = [
  {
    id: 947,
    created_at: 1698700721076,
    content:
      'A mobile phone plan charges a flat fee of $40 per month plus $0.10 per minute for talk time. Write an equation to represent the total cost, C, for t minutes of talk time in a month.',
    options: [[]],
    answer:
      'The equation to represent the total cost, C, for t minutes of talk time in a month would be: C = 40 + 0.10t. Here, 40 is the flat fee per month and 0.10t represents the cost per minute of talk time.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The equation to represent the total cost, C, for t minutes of talk time in a month would be: C = 40 + 0.10t. Here, 40 is the flat fee per month and 0.10t represents the cost per minute of talk time.',
    ],
  },
  {
    id: 946,
    created_at: 1698700709353,
    content:
      'A tutoring service charges a flat fee of $30 for the first hour plus $20 per hour for each additional hour. Write an equation to represent the total cost, C, for d hours of tutoring.',
    options: [[]],
    answer:
      'The equation representing the total cost, C, for d hours of tutoring can be written as:\n\nC = 30 + 20(d - 1)\n\nThis equation shows that the total cost is $30 for the first hour and then $20 for each additional hour. Note, when d is 1 (one hour of tutoring), the equation simplifies to C = 30 as expected. For any d > 1, the cost increases by $20 for each additional hour.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The equation representing the total cost, C, for d hours of tutoring can be written as:\n\nC = 30 + 20(d - 1)\n\nThis equation shows that the total cost is $30 for the first hour and then $20 for each additional hour. Note, when d is 1 (one hour of tutoring), the equation simplifies to C = 30 as expected. For any d > 1, the cost increases by $20 for each additional hour.',
    ],
  },
  {
    id: 945,
    created_at: 1698700681837,
    content:
      'A landscaping company charges a flat fee of $100 for consultation plus $25 per hour of work. Write an equation to represent the total cost, C, for a consultation and d hours of work.2. A taxi service charges a flat fee of $5 for pickup plus $2.50 per mile driven. Write an equation to represent the total cost, C, for a ride of d miles.',
    options: [[]],
    answer:
      '1. For the landscaping company, the total cost, C, is made up of a flat fee of $100 and the hourly rate of $25. So, for d hours of work, the equation would be C = 100 + 25d.\n\n2. For the taxi service, the total cost, C, is made up of a flat fee of $5 and the rate of $2.50 per mile. So, for a ride of d miles, the equation would be C = 5 + 2.50d.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      '1. For the landscaping company, the total cost, C, is made up of a flat fee of $100 and the hourly rate of $25. So, for d hours of work, the equation would be C = 100 + 25d.\n\n2. For the taxi service, the total cost, C, is made up of a flat fee of $5 and the rate of $2.50 per mile. So, for a ride of d miles, the equation would be C = 5 + 2.50d.',
    ],
  },
  {
    id: 944,
    created_at: 1698700656330,
    content:
      'A restaurant charges a flat fee of $15 for delivery plus $50 per mile. Write an equation to represent the total cost, C, for delivering an order for d miles.',
    options: [[]],
    answer:
      'The equation that represents the total cost, C, for delivering an order for d miles is C = 15 + 50d.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The equation that represents the total cost, C, for delivering an order for d miles is C = 15 + 50d.',
    ],
  },
  {
    id: 943,
    created_at: 1698700608211,
    content:
      'A student is saving money to buy a smartphone. The cost of the smartphone is $500, and the student can save $20 per week. Write an equation to represent the total cost, C, for buying the smartphone after s weeks.',
    options: [[]],
    answer:
      'The equation to represent the total cost, C, for buying the smartphone after s weeks is C = 500 - 20s.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The equation to represent the total cost, C, for buying the smartphone after s weeks is C = 500 - 20s.',
    ],
  },
  {
    id: 942,
    created_at: 1698700597056,
    content:
      'A company produces three types of products, A, B, and C. Each unit of product A requires 2 hours of labor, each unit of product B requires 4 hours of labor, and each unit of product C requires 6 hours of labor. If the company has a total of 30 hours of labor available, write a system of inequalities to represent this constraint.',
    options: [[]],
    answer:
      "Let's denote the number of units produced for products A, B, and C as a, b, and c respectively. \n\nThe total hours of labor required for producing these products should be less than or equal to the total hours available, which is 30 hours. \n\nThis can be represented as the following inequality: \n\n2a + 4b + 6c ≤ 30 \n\nSince the number of units produced cannot be negative, we also have the following inequalities: \n\na ≥ 0\nb ≥ 0\nc ≥ 0 \n\nSo, the system of inequalities representing this constraint is:\n\n2a + 4b + 6c ≤ 30\na ≥ 0\nb ≥ 0\nc ≥ 0",
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      "Let's denote the number of units produced for products A, B, and C as a, b, and c respectively. \n\nThe total hours of labor required for producing these products should be less than or equal to the total hours available, which is 30 hours. \n\nThis can be represented as the following inequality: \n\n2a + 4b + 6c ≤ 30 \n\nSince the number of units produced cannot be negative, we also have the following inequalities: \n\na ≥ 0\nb ≥ 0\nc ≥ 0 \n\nSo, the system of inequalities representing this constraint is:\n\n2a + 4b + 6c ≤ 30\na ≥ 0\nb ≥ 0\nc ≥ 0",
    ],
  },
  {
    id: 941,
    created_at: 1698700568986,
    content:
      'A store sells two types of products, X and Y. The store wants to make at least $500 in sales. If the price of product X is $10 and the price of product Y is $20, write an inequality to represent this constraint.',
    options: [[]],
    answer:
      'The inequality to represent this constraint would be 10X + 20Y ≥ 500, where X represents the quantity of product X and Y represents the quantity of product Y.',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The inequality to represent this constraint would be 10X + 20Y ≥ 500, where X represents the quantity of product X and Y represents the quantity of product Y.',
    ],
  },
  {
    id: 940,
    created_at: 1698700557627,
    content:
      'A farmer has a rectangular field with a length of 100 meters and a width of w meters. The perimeter of the field must be less than 400 meters. Write an inequality to represent this constraint.',
    options: [[]],
    answer:
      'The perimeter P of a rectangle is calculated by the formula P = 2l + 2w, where l is the length and w is the width of the rectangle. Given that the length l is 100 meters and the perimeter must be less than 400 meters, the inequality representing this constraint would be:\n\n2(100) + 2w < 400\n\nSimplified, this becomes:\n\n200 + 2w < 400',
    assignments_id: 378,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'The perimeter P of a rectangle is calculated by the formula P = 2l + 2w, where l is the length and w is the width of the rectangle. Given that the length l is 100 meters and the perimeter must be less than 400 meters, the inequality representing this constraint would be:\n\n2(100) + 2w < 400\n\nSimplified, this becomes:\n\n200 + 2w < 400',
    ],
  },
];

export const DUMMY_ASSIGNMENT_QUESTIONS_TWO = [
  {
    id: 952,
    created_at: 1698700821009,
    content: 'Solve the quadratic equation: x^2 - 6x + 8 = 0',
    options: [[]],
    answer:
      'To solve the quadratic equation x^2 - 6x + 8 = 0, you need to use the quadratic formula, which is x = [-b ± sqrt(b^2 - 4ac)] / (2a). In this equation, a=1, b=-6, and c=8.\n\nNow you can substitute these values into the formula:\n\nx = [6 ± sqrt((-6)^2 - 4*1*8)] / (2*1)\nx = [6 ± sqrt(36 - 32)] / 2\nx = [6 ± sqrt(4)] / 2\nx = [6 ± 2] / 2\n\nSo, the solutions are:\n\nx = (6 + 2) / 2 = 4\nx = (6 - 2) / 2 = 2\n\nSo, the solutions to the equation x^2 - 6x + 8 = 0 are x = 2 and x = 4.',
    assignments_id: 379,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'To solve the quadratic equation x^2 - 6x + 8 = 0, you need to use the quadratic formula, which is x = [-b ± sqrt(b^2 - 4ac)] / (2a). In this equation, a=1, b=-6, and c=8.\n\nNow you can substitute these values into the formula:\n\nx = [6 ± sqrt((-6)^2 - 4*1*8)] / (2*1)\nx = [6 ± sqrt(36 - 32)] / 2\nx = [6 ± sqrt(4)] / 2\nx = [6 ± 2] / 2\n\nSo, the solutions are:\n\nx = (6 + 2) / 2 = 4\nx = (6 - 2) / 2 = 2\n\nSo, the solutions to the equation x^2 - 6x + 8 = 0 are x = 2 and x = 4.',
    ],
  },
  {
    id: 951,
    created_at: 1698700818395,
    content: 'Solve the quadratic equation: 4x^2 - 9 = 0',
    options: [[]],
    answer:
      "The given quadratic equation is 4x^2 - 9 = 0. \n\nFirst, let's isolate the x^2 term by adding 9 to both sides of the equation:\n\n4x^2 = 9\n\nThen, divide both sides by 4:\n\nx^2 = 9/4\n\nNow, to solve for x, take the square root of both sides. Remember, when you take the square root of a square, there are two possible solutions: a positive and a negative:\n\nx = sqrt(9/4) or x = -sqrt(9/4)\n\nThis simplifies to:\n\nx = 3/2 or x = -3/2\n\nSo, the solutions of the given quadratic equation are x = 3/2 and x = -3/2.",
    assignments_id: 379,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      "The given quadratic equation is 4x^2 - 9 = 0. \n\nFirst, let's isolate the x^2 term by adding 9 to both sides of the equation:\n\n4x^2 = 9\n\nThen, divide both sides by 4:\n\nx^2 = 9/4\n\nNow, to solve for x, take the square root of both sides. Remember, when you take the square root of a square, there are two possible solutions: a positive and a negative:\n\nx = sqrt(9/4) or x = -sqrt(9/4)\n\nThis simplifies to:\n\nx = 3/2 or x = -3/2\n\nSo, the solutions of the given quadratic equation are x = 3/2 and x = -3/2.",
    ],
  },
  {
    id: 950,
    created_at: 1698700815369,
    content: 'Solve the quadratic equation: x^2 + 7x + 10 = 0',
    options: [[]],
    answer:
      'To solve the quadratic equation x^2 + 7x + 10 = 0, we can use the formula x = [-b ± sqrt(b^2 - 4ac)] / 2a. \n\nIn this equation, a = 1, b = 7 and c = 10. \n\nFirst, calculate the term under the square root in the formula, which is b^2 - 4ac = (7^2) - 4*1*10 = 49 - 40 = 9.\n\nThen, calculate the square root of this term, which is sqrt(9) = 3.\n\nNow, plug these values into the formula to find the roots of the equation:\n\nx = [-7 ± 3] / 2*1 = -7/2 ± 3/2.\n\nThis gives us two solutions:\n\nx1 = (-7 + 3)/2 = -2,\nx2 = (-7 - 3)/2 = -5.\n\nSo, the solutions of the equation x^2 + 7x + 10 = 0 are x = -2 and x = -5.',
    assignments_id: 379,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'To solve the quadratic equation x^2 + 7x + 10 = 0, we can use the formula x = [-b ± sqrt(b^2 - 4ac)] / 2a. \n\nIn this equation, a = 1, b = 7 and c = 10. \n\nFirst, calculate the term under the square root in the formula, which is b^2 - 4ac = (7^2) - 4*1*10 = 49 - 40 = 9.\n\nThen, calculate the square root of this term, which is sqrt(9) = 3.\n\nNow, plug these values into the formula to find the roots of the equation:\n\nx = [-7 ± 3] / 2*1 = -7/2 ± 3/2.\n\nThis gives us two solutions:\n\nx1 = (-7 + 3)/2 = -2,\nx2 = (-7 - 3)/2 = -5.\n\nSo, the solutions of the equation x^2 + 7x + 10 = 0 are x = -2 and x = -5.',
    ],
  },
  {
    id: 949,
    created_at: 1698700811922,
    content: 'Solve the quadratic equation: 2x^2 - 5x + 2 = 0',
    options: [[]],
    answer:
      'To solve the quadratic equation 2x^2 - 5x + 2 = 0, you can use the quadratic formula which is x = [-b ± sqrt(b^2 - 4ac)] / (2a). Given that in the equation 2x^2 - 5x + 2 = 0, a is 2, b is -5, and c is 2, you can substitute these values into the quadratic formula.\n\nSo, x = [5 ± sqrt((-5)^2 - 4*2*2)] / (2*2),\nx = [5 ± sqrt(25 - 16)] / 4,\nx = [5 ± sqrt(9)] / 4,\nx = [5 ± 3] / 4.\n\nTherefore, the solutions of the equation are x = 8/4 = 2 and x = 2/4 = 0.5.',
    assignments_id: 379,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'To solve the quadratic equation 2x^2 - 5x + 2 = 0, you can use the quadratic formula which is x = [-b ± sqrt(b^2 - 4ac)] / (2a). Given that in the equation 2x^2 - 5x + 2 = 0, a is 2, b is -5, and c is 2, you can substitute these values into the quadratic formula.\n\nSo, x = [5 ± sqrt((-5)^2 - 4*2*2)] / (2*2),\nx = [5 ± sqrt(25 - 16)] / 4,\nx = [5 ± sqrt(9)] / 4,\nx = [5 ± 3] / 4.\n\nTherefore, the solutions of the equation are x = 8/4 = 2 and x = 2/4 = 0.5.',
    ],
  },
  {
    id: 948,
    created_at: 1698700807300,
    content: 'Solve the quadratic equation: 3x^2 - 8x - 3 = 0',
    options: [[]],
    answer:
      'To solve the quadratic equation 3x^2 - 8x - 3 = 0, we can use the quadratic formula, which is x = [-b ± sqrt(b^2 - 4ac)] / 2a.\n\nHere, a, b, and c are coefficients from the quadratic equation ax^2 + bx + c = 0. For this equation, a = 3, b = -8, and c = -3.\n\nSubstituting these values into the quadratic formula gives:\n\nx = [8 ± sqrt((-8)^2 - 4*3*(-3))] / 2*3\nx = [8 ± sqrt(64 + 36)] / 6\nx = [8 ± sqrt(100)] / 6\nx = [8 ± 10] / 6\n\nThis gives us two solutions:\n\nx = (8 + 10) / 6 = 3\nx = (8 - 10) / 6 = -1/3\n\nSo, the solutions to the quadratic equation 3x^2 - 8x - 3 = 0 are x = 3 and x = -1/3.',
    assignments_id: 379,
    assignment_type_id: 2,
    assignment_question_media_id: 0,
    user_id: 3723,
    assignment_option_media_images: [],
    substitute_teacher_user_id: 0,
    assignment_type: {
      id: 2,
      created_at: 1669105685014,
      type: 'Text',
    },
    splittedAnswer: [
      'To solve the quadratic equation 3x^2 - 8x - 3 = 0, we can use the quadratic formula, which is x = [-b ± sqrt(b^2 - 4ac)] / 2a.\n\nHere, a, b, and c are coefficients from the quadratic equation ax^2 + bx + c = 0. For this equation, a = 3, b = -8, and c = -3.\n\nSubstituting these values into the quadratic formula gives:\n\nx = [8 ± sqrt((-8)^2 - 4*3*(-3))] / 2*3\nx = [8 ± sqrt(64 + 36)] / 6\nx = [8 ± sqrt(100)] / 6\nx = [8 ± 10] / 6\n\nThis gives us two solutions:\n\nx = (8 + 10) / 6 = 3\nx = (8 - 10) / 6 = -1/3\n\nSo, the solutions to the quadratic equation 3x^2 - 8x - 3 = 0 are x = 3 and x = -1/3.',
    ],
  },
];
